// components/HamburgerMenu.js
import React from 'react';

const HamburgerMenu = ({ isOpen, onToggle, onItemClick, user, currentSet, showResult, location, handleLogout }) => {
  return (
    <div className={`hamburger-menu ${isOpen ? 'open' : ''}`}>
      <button className="hamburger-button" onClick={onToggle}>
        <span></span>
        <span></span>
        <span></span>
      </button>

      {isOpen && (
        <div className="menu-items">
          <button onClick={() => {
            onItemClick();
            onToggle();
          }}>
            Select Set
          </button>

          {currentSet && currentSet.length > 0 && !showResult && location.pathname === '/' && (
            <button onClick={() => {
              onItemClick('order');
              onToggle();
            }}>
              Change Order
            </button>
          )}

          <button onClick={() => {
            onItemClick('profile');
            onToggle();
          }}>
            User Profile
          </button>

          <button onClick={() => {
            handleLogout();
            onToggle();
          }}>
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default HamburgerMenu;